import { CrudState } from "@/store/modules/crud/State";

export class PositionState extends CrudState {
  swapped: boolean = false;
}
